<template>
  <div class="single-voucher">
    <!-- top -->
    <div class="item-top">
      <span class="unit">{{ $t('CURRENCY_UNIT') }}</span>
      <span class="amount">{{ showAmount }}</span>
      <span class="typefix">OFF</span>
    </div>

    <!-- below -->
    <div class="item-below">
      <div class="item-minStake">
        {{ stakeDesc }}
      </div>
      <div
        class="item-time"
        :class="{'expiresToday': diffTime <= 1}"
      >
        {{ timeDesc }}
      </div>
    </div>

    <div
      v-if="isAppOnly"
      class="item-platform"
    >
      App Only
    </div>
  </div>
</template>

<script>
import useVoucherMixin from './useVoucherMixin.js'

export default {
  name: 'SingleVoucher',
  props: {
    data: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  setup() {
    const { isAppOnly, stakeDesc, diffTime, timeDesc, showAmount } = useVoucherMixin()

    return {
      isAppOnly,
      stakeDesc,
      diffTime,
      timeDesc,
      showAmount
    }
  }
}
</script>
<style lang="less">
@import url("~wap/common/style/variable.less");

.single-voucher {
  position: relative;
  overflow: hidden;
  width: 240px;
  padding: 10px;
  border-radius: 4px;
  margin: 0 auto;
  background: url("../images/voucher.png") no-repeat center;
  background-size: 100%;
  text-align: left;

  .item-platform {
    top: 10px;
    left: 10px;
    border-radius: 4px 0 10px;
  }

  .unit {
    color: #3a3a3a;
    font-family: LucidaGrande;
    font-size: 36px;
  }

  .amount {
    color: #333;
    font-size: 54px;
    line-height: 1;
  }

  .typefix {
    color: #333;
    font-size: 24px;
  }

  .item-top {
    width: 100%;
    height: 60px;
    padding: 13px 23px 0;
    white-space: nowrap;
  }

  .item-below {
    padding: 11px 23px 10px;
    color: #333;

    .item-minStake {
      font-size: 14px;
      line-height: 18px;
    }

    .item-time {
      margin-top: 4px;
      font-size: 10px;
      line-height: 14px;
    }

    .expiresToday {
      color: #e51717;
    }
  }
}
</style>
